import { Icon } from 'idea-react';
import { observer } from 'mobx-react';
import { Component } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';

import { I18nKey, t } from '../model/Translation';

interface ReportTemplateMeta {
    id: string;
    nameKey: string; // translation key for template name
    charCount: number;
    relatedData: number;
    descriptionKey: string; // translation key for description
}

const reportTemplates: ReportTemplateMeta[] = [
    {
        id: 'weekly',
        nameKey: 'weekly_report_template',
        charCount: 5232,
        relatedData: 10,
        descriptionKey: 'weekly_report_description'
    },
    {
        id: 'monthly',
        nameKey: 'monthly_report_template',
        charCount: 5232,
        relatedData: 10,
        descriptionKey: 'monthly_report_description'
    },
    {
        id: 'quarterly',
        nameKey: 'quarterly_report_template',
        charCount: 5232,
        relatedData: 10,
        descriptionKey: 'quarterly_report_description'
    }
];

@observer
export class ReportTemplateListPage extends Component {
    renderTemplateCard = ({
        id,
        nameKey,
        charCount,
        relatedData,
        descriptionKey
    }: ReportTemplateMeta) => (
        <Col key={id} md={4} className="d-flex">
            <Card className="flex-fill shadow-sm" body>
                <a
                    className="text-decoration-none d-flex align-items-start gap-3"
                    href={`#/report/template/${id}`}
                >
                    <div className="rounded bg-light p-3 d-flex align-items-center justify-content-center">
                        <Icon name="folder" className="text-primary" />
                    </div>
                    <div className="flex-fill">
                        <h5 className="mb-2">{t(nameKey as I18nKey)}</h5>
                        <small className="text-muted d-block mb-2">
                            {charCount}
                            {t('chars_unit')} · +{relatedData}
                            {t('related_data_unit')}
                        </small>
                        <p className="mb-0 text-secondary small">
                            {t(descriptionKey as I18nKey)}
                        </p>
                    </div>
                </a>
            </Card>
        </Col>
    );

    render() {
        return (
            <Container className="py-4" fluid>
                <h4 className="mb-4">{t('report_template_library')}</h4>
                <Row className="g-3">
                    {reportTemplates.map(this.renderTemplateCard)}
                </Row>
            </Container>
        );
    }
}
